@let currentNotification = internalNotificationsStore.notification();

@if (currentNotification) {
  <div class="notification-wrapper">
    <div #notification class="notification {{ visible() ? 'visible' : '' }}">
      <div class="d-flex">
        <div class="message-icon">
          <i class="fa-solid fa-xl {{ icon() }}"></i>
          <div class="message">
            {{ currentNotification.message }}
          </div>
        </div>
        <i class="close fa-solid fa-x" (click)="dismissNotification(currentNotification)"></i>
      </div>
      <div class="row p-3">
        <app-generic-button [disabled]="currentNotification.techDetails == undefined"
                            [buttonText]="'Details'"
                            [description]="'Show details'"
                            (click)="showTechDetails = !showTechDetails"/>
        @if (showTechDetails) {
          <div class="tech-details">
            {{ currentNotification.techDetails }}
          </div>
        }
      </div>
    </div>

  </div>
}
